import React from 'react'
import PropTypes from 'prop-types'
import {withStyles} from 'material-ui/styles'
import compose from 'recompose/compose'
import withWidth from 'material-ui/utils/withWidth'
import Typography from 'material-ui/Typography'
import {Button} from '../../../components'
import {yours as text} from '../text'
import FirstLogin from '../../firstlogin/FirstLogin'
import Deposit from '../../deposit/containers/deposit'
import MissingInfo from '../../missingInfo/containers/missingInfo'
import Costs from '../containers/costs'
import {PRICES_AVAILABLE} from "../../../App"

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginBottom: 50,
    padding: 25,
  },
  wrapper: {
    maxWidth: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: 30,
  },
  messageBody: {
    maxWidth: 400,
    margin: '10px auto',
  },
  buttonWrapper: {
    maxWidth: 250,
    width: '100%',
    margin: '0 auto',
  },
}

const NoObjects = ({classes, startDeposit, openCosts, firstLoginProps = {}}) => (
  <div className={classes.container}>

    <div className={classes.wrapper}>
      <Typography variant='headline' align='center' gutterBottom={true}>{text.noObjectsMessage.title}</Typography>
      <Typography variant="body1" gutterBottom align={'center'} className={classes.messageBody}>
        {text.noObjectsMessage.body}
      </Typography>
      <img
        src='/assets/noItems.png' alt='no items'
        width={100} height={100} style={{objectFit: 'scale-down', marginBottom: 25}}
      />
      <div className={classes.buttonWrapper}>
        {PRICES_AVAILABLE && <Button variant="secondary" fullWidth={true} style={{marginBottom: 10}} onClick={() => openCosts()}>{text.noObjectsMessage.costsButton}</Button>}
        <Button variant="primary" fullWidth={true} onClick={() => startDeposit()}>{text.noObjectsMessage.depositButton}</Button>
      </div>
    </div>

    <div className={classes.wrapper}>
      <Typography variant="headline" align="center" gutterBottom={true}>{text.noObjectsMessage.title2}</Typography>
      <Typography variant="body1" gutterBottom align="center" className={classes.messageBody}>
        {text.noObjectsMessage.body2}
      </Typography>
      <img
        src='/assets/depositDone.svg' alt='guide'
        width={350} height={75} style={{objectFit: 'scale-down', marginBottom: 25}}
      />
      <div className={classes.buttonWrapper}>
        <Button variant="primary" fullWidth={true} onClick={() => {
          window.location = process.env.REACT_APP_LANDING_URL + '/guia-almacenamiento.html'
        }}>{text.noObjectsMessage.storageGuideButton}</Button>
      </div>
    </div>

    <FirstLogin {...firstLoginProps}/>
    <Costs/>
    <Deposit/>
    <MissingInfo/>
  </div>
)

NoObjects.propTypes = {
  startDeposit: PropTypes.func.isRequired,
  openCosts: PropTypes.func.isRequired,
  isFirstLoginOpen: PropTypes.bool,
  firstLoginProps: PropTypes.object,
}

export default compose(withStyles(styles, {withTheme: true}), withWidth())(NoObjects)



// WEBPACK FOOTER //
// ./src/sections/yours/components/NoObjects.jsx